import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module')
      .then(m => m.HomeModule)
  },
  {
    path: 'articles',
    loadChildren: () => import('./pages/articles/articles.module')
      .then(m => m.ArticlesModule)
  },
  {
    path: 'guides',
    loadChildren: () => import('./pages/guides/guides.module')
      .then(m => m.GuidesModule)
  },
  {
    path: 'symbol-character',
    loadChildren: () => import('./pages/utility/symbol-character/symbol-character.module')
      .then(m => m.SymbolCharacterModule)
  },
  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    //initialNavigation: 'enabled'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
